import { yupResolver } from "@hookform/resolvers/yup";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import * as React from "react";
import { useForm } from "react-hook-form";
import CancelPresentationIconButton from "../../../common/components/Buttons/CancelPresentationIconButton";
import DropdownField from "../../../common/components/FormFields/DropdownField";
import DatePickerField from "../../../common/components/FormFields/DatePickerFieldNew";
import InputField from "../../../common/components/FormFields/InputField";
import { getDepartment } from "../services/EMRServices/emrServices";
import { getDoctor } from "../services/EMRServices/oncologyServices";
import CommonButton from "../../../common/components/Buttons/CommonButton";
// import { getDoctorsList } from "../../../IPD/services/admissiondetails/admissionDetailsService";
import { format } from "date-fns";

const ModalStyles = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "40%",
  bgcolor: "background.paper",
  border: "1px solid gray",
  boxShadow: 20,
  p: 4,
};

export default function AdviceAdmissionModal(props) {
  const loggedUser = JSON.parse(localStorage.getItem("loggedUser"));
  const [departments, setDepartments] = React.useState([]);
  const [doctors, setDoctors] = React.useState([]);

  React.useEffect(() => {
    getDepartment()
      .then((response) => response.data)
      .then((res) => {
        setDepartments(res?.result);
      })
      .catch((err) => err);
  }, []);

  const {
    control,
    register,
    setValue,
    reset,
    getValues,
    watch,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    // resolver: yupResolver(schema),
    defaultValues: {
      tentativeAdmissionDate: new Date(),
      lengthOfStay: 0,
      admittingDoctor: null,
      admittingDepartment: null,
    },
  });

  const [admissionDate, departmentWatch, doctorWatch, lengthOfStay] = watch([
    "tentativeAdmissionDate",
    "admittingDepartment",
    "admittingDoctor",
    "lengthOfStay",
  ]);

  React.useEffect(() => {
    let doctorObject = {
      id: props?.editData?.admittingDoctorId,
      value: props?.editData?.admittingDoctorId,
      label: props?.editData?.admittingDoctor,
    };
    let departmentObject = {
      id: props?.editData?.admittingDepartmentId,
      value: props?.editData?.admittingDepartmentId,
      label: props?.editData?.admittingDepartment,
    };

    let adviceObject = {
      admissionTentativeDate: props?.editData?.admissionTentativeDate,
      stayLength: Number(props?.editData?.stayLength),
      admittingDepartmentId: props?.editData?.admittingDepartmentId,
      admittingDepartment: props?.editData?.admittingDepartment,
      admittingDoctorId: props?.editData?.admittingDoctorId,
      admittingDoctor: props?.editData?.admittingDoctor,
    };
    props.setAdviceDetails(adviceObject);

    if (props?.editData?.admissionTentativeDate !== null) {
      let dateString = new Date(
        props?.editData?.admissionTentativeDate
          ?.toString()
          ?.replaceAll("-", "/")
      );
      setValue("tentativeAdmissionDate", dateString);
    }
    setValue("lengthOfStay", props?.editData?.stayLength);
    setValue("admittingDoctor", doctorObject);
    setValue("admittingDepartment", departmentObject);
  }, [props.editData]);

  React.useEffect(() => {
    if (departmentWatch?.id > 0) {
      // getDoctorsList(departmentWatch?.id)
      //   .then((response) => response.data)
      //   .then((res) => {
      //     setDoctors(res?.result);
      //   })
      //   .catch((error) => error);
    }
  }, [departmentWatch]);

  const onSubmitDataHandler = (data) => {
    let adviceObject = {
      admissionTentativeDate: format(
        data?.tentativeAdmissionDate,
        "yyyy-MM-dd"
      ),
      stayLength: Number(data?.lengthOfStay),
      admittingDepartmentId: data?.admittingDepartment?.id,
      admittingDepartment: data?.admittingDepartment?.label,
      admittingDoctorId: data?.admittingDoctor?.id,
      admittingDoctor: data?.admittingDoctor?.label,
    };
    props.setAdviceDetails(adviceObject);
    props?.close();
  };

  return (
    <div>
      <div>
        <Modal
          open={props.open}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={ModalStyles}>
            <CancelPresentationIconButton
              onClick={() => {
                // props?.handleAdmissionField();
                props.close();
              }}
            />
            <form onSubmit={handleSubmit(onSubmitDataHandler)}>
              <div className=" text-lg font-semibold">Advice Admission</div>
              <div className="my-2 grid grid-cols-2 gap-2 items-center">
                <div className="">
                  <DatePickerField
                    control={control}
                    name={"tentativeAdmissionDate"}
                    label={"Ten. Date of Admission"}
                    inputFormat={"dd/MM/yyyy"}
                    disablePast={true}
                  />
                </div>
                <div className="">
                  <InputField
                    control={control}
                    name={"lengthOfStay"}
                    label={"Length Of Stay"}
                  />
                </div>
                <div className="">
                  <DropdownField
                    control={control}
                    name={"admittingDepartment"}
                    placeholder={"Admitting Department"}
                    dataArray={departments}
                  />
                </div>
                <div className="">
                  <DropdownField
                    control={control}
                    name={"admittingDoctor"}
                    placeholder={"Admitting Doctor"}
                    dataArray={doctors}
                  />
                </div>
              </div>
              <div className="my-2 flex justify-end gap-2 items-center">
                <CommonButton
                  label={"Reset"}
                  className={
                    "px-3 rounded border border-customRed text-customRed"
                  }
                  type={"button"}
                  onClick={reset}
                />
                <CommonButton
                  label={"Save"}
                  className={"px-3 rounded bg-customGreen text-white "}
                  type={"submit"}
                />
              </div>
            </form>
          </Box>
        </Modal>
      </div>
    </div>
  );
}

